import type { LandingLayout, LandingLayoutDefinition, LandingTokens } from './types';

/** An unbranded page is the common case, so its build is shared rather than repeated per mount. */
const defaults = new WeakMap<LandingLayoutDefinition, LandingLayout>();

export function buildLayout(
  definition: LandingLayoutDefinition,
  overrides?: Partial<LandingTokens>,
): LandingLayout {
  const cached = overrides ? undefined : defaults.get(definition);
  if (cached) return cached;

  const tokens: LandingTokens = overrides
    ? { ...definition.tokens, ...overrides }
    : definition.tokens;
  const { styles } = definition;

  const layout: LandingLayout = {
    id: definition.id,
    tokens,
    fontsHref: definition.fontsHref,
    shared: styles.shared(tokens),
    chrome: styles.chrome(tokens),
    hero: styles.hero(tokens),
    content: styles.content(tokens),
    media: styles.media(tokens),
    plans: styles.plans(tokens),
    faq: styles.faq(tokens),
    closingCta: styles.closingCta(tokens),
    components: definition.components,
  };

  if (!overrides) defaults.set(definition, layout);

  return layout;
}
